import { PublicIdSchemas } from '@idc-forms/id'
import { z } from 'zod'
import { DurationSecondsSchema, InstantSchema, LocalDateSchema } from '../primitives/time'
import { V2CursorPaginationSchema } from './http'

export const V2EntityReferenceSchema = z.object({
  id: z
    .union([
      PublicIdSchemas.client,
      PublicIdSchemas.project,
      PublicIdSchemas.property,
      PublicIdSchemas.state,
      PublicIdSchemas.user
    ])
    .nullable(),
  code: z.union([z.string(), z.number()]).nullable(),
  name: z.string().nullable()
})

export const V2NegotiationAnalyticsRowSchema = z.object({
  id: PublicIdSchemas.negotiation,
  code: z.number().int(),
  startDate: LocalDateSchema.nullable(),
  endDate: LocalDateSchema.nullable(),
  currentState: V2EntityReferenceSchema.nullable(),
  project: V2EntityReferenceSchema.nullable(),
  property: V2EntityReferenceSchema.nullable(),
  society: z.object({ name: z.string().nullable() }).nullable(),
  advisor: V2EntityReferenceSchema.nullable(),
  createdBy: V2EntityReferenceSchema.nullable(),
  clients: z.array(V2EntityReferenceSchema.extend({ principal: z.boolean() })),
  createdAt: InstantSchema.nullable(),
  updatedAt: InstantSchema.nullable()
})

export const V2NegotiationStateVisitSchema = z.object({
  negotiationId: PublicIdSchemas.negotiation,
  negotiationCode: z.number().int(),
  stateId: PublicIdSchemas.state.nullable(),
  stateName: z.string().nullable(),
  stateType: z.string().nullable(),
  enteredAt: InstantSchema.nullable(),
  exitedAt: InstantSchema.nullable(),
  durationSeconds: DurationSecondsSchema.nullable(),
  rejected: z.boolean()
})

export const V2NegotiationCycleTimeSchema = z.object({
  negotiationId: PublicIdSchemas.negotiation,
  code: z.number().int(),
  startedAt: InstantSchema.nullable(),
  closedAt: InstantSchema.nullable(),
  cycleDurationSeconds: DurationSecondsSchema.nullable(),
  currentState: V2EntityReferenceSchema.nullable()
})

export const V2NegotiationsPageSchema = z.object({
  data: z.array(V2NegotiationAnalyticsRowSchema),
  pagination: V2CursorPaginationSchema
})

export const V2StateVisitsPageSchema = z.object({
  data: z.array(V2NegotiationStateVisitSchema),
  pagination: V2CursorPaginationSchema
})

export const V2StateVisitsResultSchema = z.object({
  data: z.array(V2NegotiationStateVisitSchema)
})

export const V2CycleTimesPageSchema = z.object({
  data: z.array(V2NegotiationCycleTimeSchema),
  pagination: V2CursorPaginationSchema
})

/** Job de export asíncrono; downloadUrl aparece sólo cuando está completado. */
export const V2ExportJobSchema = z.object({
  id: PublicIdSchemas.export,
  dataset: z.union([z.literal('negotiation-state-visits'), z.literal('negotiation-cycle-times')]),
  status: z.union([
    z.literal('pending'),
    z.literal('processing'),
    z.literal('completed'),
    z.literal('failed')
  ]),
  rowCount: z.number().int().nullable(),
  expiresAt: InstantSchema,
  createdAt: InstantSchema,
  completedAt: InstantSchema.nullable(),
  failedAt: InstantSchema.nullable(),
  downloadUrl: z.string().url().optional()
})
